import type { EmbodimentOutline } from '@/domains/specification/apis/create-embodiment-outline-api';
import type { Model } from '@patsnap/tahiti-core';

export interface SpecificationEmbodimentImprovementState {
    improvingOutlineNumber: number | undefined;
    modifiedOutline: EmbodimentOutline | undefined;
}

export const SpecificationEmbodimentImprovementModel = Symbol.for('SpecificationEmbodimentImprovementModel');

export interface SpecificationEmbodimentImprovementModel extends Model<SpecificationEmbodimentImprovementState> {}
